module.exports = __webpack_public_path__ + "img/cyber-monday.d4516621.svg";